module.exports = __webpack_public_path__ + "static/media/historyA.e13083af.jpg";